/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Findanswerstocommonqu4Inputs */

const en_help_findanswerstocommonqu4 = /** @type {(inputs: Help_Findanswerstocommonqu4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find answers to common questions in our FAQ section.`)
};

/**
* | output |
* | --- |
* | "Find answers to common questions in our FAQ section." |
*
* @param {Help_Findanswerstocommonqu4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_findanswerstocommonqu4 = /** @type {((inputs?: Help_Findanswerstocommonqu4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Findanswerstocommonqu4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_findanswerstocommonqu4(inputs)
});
export { help_findanswerstocommonqu4 as "help_findAnswersToCommonQu" }